import * as React from 'react';

const ChatbotShapeSmile = (props: React.SVGAttributes<SVGElement>) => {
	return (
		<svg viewBox="0 0 30 32" {...props}>
			<g fillRule="nonzero" fill="none">
				<path
					d="M15.006 0C23.293 0 30 6.699 30 14.947c0 4.124-1.683 7.864-4.394 10.566l1.028 4.637c.295 1.306-1.144 2.331-2.287 1.614l-4.908-2.536c-1.4.435-2.904.666-4.445.666C6.707 29.894 0 23.195 0 14.947S6.72 0 15.006 0z"
					fill="#00BE59"
				/>
				<path
					d="M22.467 16h-1.644a.568.568 0 00-.544.456c-.521 2.723-2.902 4.786-5.77 4.786-2.869 0-5.25-2.063-5.771-4.786A.55.55 0 008.193 16H6.55c-.34 0-.59.296-.545.638C6.618 20.81 10.19 24 14.497 24c4.308 0 7.88-3.202 8.492-7.362a.525.525 0 00-.522-.638"
					fill="#B9F9C7"
				/>
			</g>
		</svg>
	);
};

export default ChatbotShapeSmile;
